import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components/native'

import { faPlusCircle } from '@fortawesome/pro-light-svg-icons'

import { FaIcon } from '../../../App/Components'
import { Link, useParams } from '../../../Router'
import { IAppState } from '../../../store/IAppState'
import { setCurrentCustomerIndex } from '../../store/Actions'
import StyleVariables from '../../../StyleVariables'

import { IProps } from './IProps'

const ButtonContainer = styled.View<{ color: string }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 6px ${StyleVariables.horizontalGutter};
  border: 1px solid ${({ color }) => color};
  border-radius: ${StyleVariables.borderRadiusPill};
  align-self: center;
  margin-top: 8px;
`

const ButtonText = styled.Text<{ color: string }>`
  font-size: ${StyleVariables.fontSizeBase};
  color: ${({ color }) => color};
  margin-left: 10px;
`

export const AddActivityButton: FunctionComponent<IProps> = ({
  showButton,
  customerIndex,
}) => {
  const { establishmentId } = useParams<{ establishmentId: string }>()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const settings = useSelector(
    (state: IAppState) => state.settings.values,
  )

  if (!showButton) {
    return null
  }

  const { highlightColor } = settings

  return (
    <Link
      style={{ textDecoration: 'none', width: 'fit-content', alignSelf: 'center' }}
      to={`/${establishmentId}/activities`}
      onClick={() => dispatch(setCurrentCustomerIndex(customerIndex))}
    >
      <ButtonContainer color={highlightColor}>
        <FaIcon size="lg" icon={faPlusCircle} color={highlightColor} />
        <ButtonText color={highlightColor}>{t('Add extra activity')}</ButtonText>
      </ButtonContainer>
    </Link>
  )
}
